export enum DiagnosisModalViewMode {
  TABLE = "table",
  THINKING = "thinking",
}
